import React from 'react';
import { Stack, Typography } from '@mui/material';

export function WidgetPrimaryData ({ title, value, border = true, position, titleStyles, valueStyles }) {
    return (
        <Stack direction={position !== undefined ? position : 'column'} alignItems={'center'} justifyContent={'center'} paddingRight={'20px'} marginRight={'8px'} paddingLeft={'12px'} borderRight={border ? 'solid 2px #F95623' : ''}>
            <Typography sx={titleStyles}>{title}</Typography>
            <Typography sx={valueStyles} color={'#F95623'}>{value}</Typography>
        </Stack>
    );
}
// Title styles
// Value styles
